"use client";

import { useState } from "react";
import {
  Dialog,
  DialogPortal,
  DialogBackdrop,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
  DialogFooter,
  DialogClose,
  Button,
} from "@/ui";
import TextField from "@components/shared/form/TextField";
import FormSection from "./parts/FormSection";
import FormFieldTitle from "./parts/FormFieldTitle";

export default function EditCulture({ onClose, open, candidate, onSave }) {
  const [culture, setCulture] = useState({
    personality_summary: candidate?.personality_summary || "",
    work_style: candidate?.work_style || "",
    personal_story: candidate?.personal_story || "",
  });

  const handleChange = (event) => {
    setCulture({ ...culture, [event.target.name]: event.target.value });
  };

  const handleSubmit = () => {
    onSave({ ...candidate, ...culture });
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogPortal>
        <DialogBackdrop />
        <DialogContent size="lg">
          <DialogHeader>
            <DialogTitle>Edit culture & personality</DialogTitle>
            <DialogClose />
          </DialogHeader>
          <DialogBody>
            <FormSection>
              <FormFieldTitle>Personality summary</FormFieldTitle>
              <TextField
                multiline
                rows={4}
                name="personality_summary"
                value={culture.personality_summary}
                onChange={handleChange}
                placeholder="Overall personality summary based on CV analysis..."
                fullWidth
              />
            </FormSection>
            <FormSection>
              <FormFieldTitle>Work style</FormFieldTitle>
              <TextField
                multiline
                rows={4}
                name="work_style"
                value={culture.work_style}
                onChange={handleChange}
                placeholder="How they approach work - pace, methodology, leadership style, and collaboration preferences..."
                fullWidth
              />
            </FormSection>
            <FormSection>
              <FormFieldTitle>Personal story</FormFieldTitle>
              <TextField
                multiline
                rows={4}
                name="personal_story"
                value={culture.personal_story}
                onChange={handleChange}
                placeholder="How they have evolved holistically throughout their career, key growth moments and professional development journey..."
                fullWidth
              />
            </FormSection>
          </DialogBody>
          <DialogFooter>
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" onClick={handleSubmit}>Save</Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
